import axios from '../Backend';
import * as settings from '../../settings'

const serverUrl = process.env.NODE_ENV === 'production' ? settings.SERVER_URL_PROD : settings.SERVER_URL_DEV

export const uploadFile = async (fileToUpload, supportFileManager = false) => {
    try {
        const filedata = new FormData();
        filedata.append('file', fileToUpload);
        filedata.append('supportFileManager', supportFileManager);
        const res = await axios.post('/files', filedata);
        const resData = res.data
        console.log('file id=', resData._id)
        return resData

    } catch (e) {
        console.log('uploadFile :: Error')
        console.log(JSON.stringify(e))
        if (e.response) {
            console.log('uploadFile :: Response Error')
            console.log(JSON.stringify(e.response.data))
        }
        throw e
    }
}

export const getFileUrl = (mediaToken, fileId) => {
    return `${serverUrl}/api/v2/files/${mediaToken}/${fileId}`
}

export const getFiles = async (page, limit, fileCategory, supportFileManager, searchInput, fileTypesLimit) => {//searchKey
    try {
        const urlExt = `/api/v2/files?page=${page}&limit=${limit}${fileCategory ? `&fileCategory=${fileCategory}` : ''}${supportFileManager ? `&supportFileManager=${supportFileManager}` : ''}${searchInput ? `&searchKey=${searchInput}` : ''}${fileTypesLimit ? `&fileTypesLimit=${fileTypesLimit}` : ''}`
        const res = await axios.get(urlExt);
        const resData = res.data?.data?.data
        return resData

    } catch (e) {
        if (e.response?.data) {
            throw e.response?.data
        }
        throw new Error(`Couldn't get files`)
        // return 'Server offline'
    }
}

export const refreshMediaToken = async () => {
    try {
        const urlExt = `/api/v2/files/generate-media-token`
        const res = await axios.post(urlExt);
        const resData = res.data?.data?.mediaTokenData
        return resData
    } catch (e) {
        if (e.response?.data) {
            throw e.response?.data
        }
        throw new Error(`Couldn't fetch media`)
    }
}

export const deleteOneFileById = async (fileId) => {
    try {
        const urlExt = `/api/v2/files/${fileId}`
        const res = await axios.delete(urlExt);
        const resData = res.data
        return resData
    } catch (e) {
        if (e.response?.data) {
            throw e.response?.data
        }
        throw new Error(`Couldn't delete file`)
    }
}


export const createEncFilesContainer = async (clientName) => {
    try {
        const urlExt = `/api/v2/files/encfile/create-container`
        const reqBody = { clientName }
        const res = await axios.post(urlExt, reqBody);
        const resData = res.data?.data
        return resData
    } catch (e) {
        if (e.response?.data) {
            throw e.response?.data
        }
        throw new Error(`Couldn't fetch media`)
    }
}

export const addFilesToEncContainer = async (referenceKey, fileId, isTheLastFileToAttach, file) => {
    try {
        const urlExt = `/api/v2/files/encfile/add-file-to-container`
        const filedata = new FormData();
        filedata.append('file', file);
        filedata.append('referenceKey', referenceKey);
        filedata.append('fileId', fileId);
        filedata.append('isTheLastFileToAttach', isTheLastFileToAttach);

        const res = await axios.post(urlExt, filedata);
        const resData = res.data?.data?.containerUrl
        return resData
    } catch (e) {
        if (e.response?.data) {
            throw e.response?.data
        }
        throw new Error(`Couldn't fetch media`)
    }
}